import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectCurrency } from "../../../features/user/userSlice";
import { formatNumber } from "../../../utils/tools";
import { Button, ButtonsContainerRetiro, ErrorSpan, Form, InputContainer } from "../DepositElements";
import mibanco from '../../../assets/images/pagomovil03.png';
import Rmibanco from '../../../assets/images/RETIRACONPAGOMOVIL.svg';

const FormBDV = ({
  form,
  handleChange,
  handleClose,
  solicitarRetiro,
  loading,
}) => {
  const [t] = useTranslation("global");
  const moneda = useSelector(selectCurrency);
  const [monto, setMonto] = useState(0);
  const [blur, setBlur] = useState(false);

  const handleMonto = (e) => {
    setBlur(true);
    handleChange(formatNumber(e));
    setMonto(parseFloat(e.target.value.replaceAll(".", "").replace(",", ".")));
    if (e.target.value === "") setMonto(0);
  };

  return (
    <Form>
      <InputContainer>
        <label>{t("deposit.documentType")}:</label>
        <select value={form.document_type} onChange={handleChange} name='document_type' >
          <option disabled value=''>{t("deposit.select-document-type")}</option>
          <option value='V'>Venezolano</option>
          <option value='E'>Extranjero</option>
        </select>
      </InputContainer>

      <InputContainer>
        <label>{t("deposit.id")}</label>
        <input
          type="text"
          placeholder={t("deposit.id")}
          name="cedula"
          value={form.cedula}
          onChange={handleChange}
        />
      </InputContainer>

      <InputContainer>
        <label>NOMBRE DEL BANCO:</label>
        <select value={form.bank_code} onChange={handleChange} name='bank_code'>
          <option disabled value=''>{t("deposit.lbl-bank")}</option>
          <option value='0102'>Banco de Venezuela</option>
          <option value='0156'>100% Banco</option>
          <option value='0172'>Bancamiga Banco Microfinanciero C.A</option>
          <option value='0114'>Bancaribe</option>
          <option value='0171'>Banco Activo</option>
          <option value='0166'>Banco Agricola de Venezuela</option>
          <option value='0175'>Banco Bicentenario del Pueblo</option>
          <option value='0128'>Banco Caroni</option>
          <option value='0163'>Banco del Tesoro</option>
          <option value='0115'>Banco Exterior</option>
          <option value='0151'>Banco Fondo Comun</option>
          <option value='0173'>Banco Internacional de Desarrollo</option>
          <option value='0105'>Banco Mercantil</option>
          <option value='0191'>Banco Nacional de Crédito</option>
          <option value='0138'>Banco Plaza</option>
          <option value='0137'>Banco Sofitasa</option>
          <option value='0104'>Banco Venezolano de Crédito</option>
          <option value='0168'>Bancrecer</option>
          <option value='0134'>Banesco</option>
          <option value='0177'>Banfanb</option>
          <option value='0146'>Bangente</option>
          <option value='0174'>Banplus</option>
          <option value='0108'>Bbva Provincial</option>  
          <option value='0157'>Delsur Banco Universal</option>
          <option value='0169'>R4 Banco Microfinanciero C.A</option>  
          <option value='0178'>N58 Banco Digital Banco Microfinanciero S.A</option>  
        </select>
      </InputContainer>

      <InputContainer>
        <label>{t("deposit.phone")}</label>
        <input
          type="text"
          placeholder={t("deposit.phone")}
          name="destination_phone"
          value={form.destination_phone}
          onChange={handleChange}
        />
      </InputContainer>

      <InputContainer>
       <label>{t("deposit.lbl-amount")}</label>
        <input
          type="text"
          placeholder="0,00"
          name="monto1"
          value={form.monto1}
          onChange={(e) => handleMonto(e)}
        />
        {monto < 100 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than-mibanco")} 100 VES
          </ErrorSpan>
        )}

        {monto > 40000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than-mibanco")} 40.000 VES {t("deposit.amount-less-than-mibancoOtro")}{" "}
          </ErrorSpan>
        )}
      </InputContainer>

     <img src={Rmibanco} alt='astropay' className={'totalpago1'} style={{width:'45%', marginLeft: '24%', marginTop: '5%', marginBottom:'2%'}}/>
     <img src={mibanco} alt='Pasarelas Tupay' className={'totalpago2'} style={{width:'140%', marginTop: '2%', marginLeft: '-22%'}}/>
      <ButtonsContainerRetiro style={{marginTop:'-160px'}}>
        <Button
          onClick={(e) => {
            e.preventDefault();
            handleClose();
          }}
        >
          {t("deposit.btn-cancel")}
        </Button>
        <Button
          primary={true}
          disabled={loading || monto < 100 || monto > 40000}
          onClick={solicitarRetiro}
        >
          {loading ? t("deposit.loading") : t("deposit.btn-next")}
        </Button>
      </ButtonsContainerRetiro>
    </Form>
  );
};

export default FormBDV;